const adminFormDefaults = {
  adminUserName: '',
  adminPassword: '',
};

export default adminFormDefaults;
